module.exports = __webpack_public_path__ + "img/payment-failure-close.7a7b79b1.svg";